// Slow Control and Fast Control each keep the last speed they were left at, so
// flipping Slow ⇄ Fast puts back where each one was instead of starting over
// at 1x. Stored as `config.speedMemory` ({ slow, fast }); anything missing or
// out of range reads as 1x.
const RANGES = {
  slow: [0.6, 1],
  fast: [1, 1.4],
};

function inRange(value, [min, max]) {
  return typeof value === "number" && value >= min && value <= max;
}

export function rememberedSpeed(memory, fast) {
  const key = fast ? "fast" : "slow";
  const value = memory?.[key];
  return inRange(value, RANGES[key]) ? value : 1;
}

// Flipping to `toFast`: remember where the side being left was, and return
// the speed to play on the side being entered.
export function flipSpeed(memory, current, toFast) {
  const leaving = toFast ? "slow" : "fast";
  const next = { ...(memory || {}) };
  if (inRange(current, RANGES[leaving])) next[leaving] = current;
  return { memory: next, speed: rememberedSpeed(next, toFast) };
}
